import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';
import moment from 'moment';

const useMasterMovie = (year: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [movieList, setMovieList] = useState<MasterMovieItemDto[]>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.master.setup.movie.list, year],
    () =>
      fetcher.master.postMasterMovieList({
        group_id: year,
      }),
    {
      onSuccess: (res: CommonListResDto) => {
        switch (res.code) {
          case 200:
            setMovieList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: movieSave } = useMutation(
    [endpoints.master.setup.movie.save ],
    fetcher.master.postMasterMovieSave,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  return { isLoading, movieList, refetch, movieSave  };
};

export default useMasterMovie;
